import {QueryCommand} from "xmgoing-server";

export const getImgIcon = function (icon) {
  if (icon?.startsWith('http')) {
    return icon;
  }

    if ((icon + '').indexOf('pe-attachment') >= 0 || (icon + '').indexOf('xmstor') >= 0) {
        return icon;
    } else {
        return `/api/pe-attachment/attachment/showImg/` + icon;
    }
}
const userAvatarCache = {}

/**
 * 用户头像hooks
 * @param loadAvatar
 */
export function useUserImgAvatarHooks({userLabel,loadAvatar,userId}) {
    const userLoadIcon = ref('');

    /**
     * 加载用户头像信息
     */
    const loadUserImg = function () {
      const queryCommand = new QueryCommand({
        url: `/api/pe-portal/users/read/${userId}`,
        method: 'POST',
        showTip: false,
      });
      //执行查询操作
      let successFun = (userJson: any) => {
        userLabel.value=userJson.realName||userJson.name;
        if (userJson && userJson.avatar) {
          userLoadIcon.value = getImgIcon(userJson.avatar);
          //换成当前用户的头像设置信息
          userAvatarCache[userJson.id] = userJson.avatar;
        }
      };
      queryCommand.executeQuery({successFun});
    }


    onMounted(() => {
        if (unref(loadAvatar)) {
            loadUserImg();
        }
    })


    return {
        userLoadIcon,
        getImgIcon,
    }
}
